import useConfirmpatient from './useConfirmPatient'
import usePostLogs from './usePostLogs'
import useResumePatient from './useResumePatient'

export {
	useConfirmpatient,
	usePostLogs,
	useResumePatient
}